import { connect } from 'react-redux';
import { RdcErrorPage } from '@saucelabs/sl-component-error-pages';

const mapStateToProps = (state) => state.apps.jobs.flatJobs.get('rdcError', {});

export default connect(mapStateToProps)(RdcErrorPage);
